// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.header-chips {
  display: flex;
  align-items: center;
  gap: 6px;
}

.header-chip {
  font-family: "SF Mono", "Monaco", "Inconsolata", "Roboto Mono", monospace;
  font-size: 0.7rem;
  letter-spacing: 0.3px;
  padding: 3px 8px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: opacity 0.15s ease, background-color 0.15s ease;
  line-height: 1.2;
}
.header-chip mat-icon {
  font-size: 12px;
  width: 12px;
  height: 12px;
}
.header-chip .chip-label {
  opacity: 0.7;
}
.header-chip:hover {
  opacity: 0.85;
}
.header-chip.chip-neutral {
  background-color: rgba(128, 128, 128, 0.15);
  color: rgba(128, 128, 128, 0.9);
}
.header-chip.chip-neutral mat-icon {
  opacity: 0.8;
}
.header-chip.chip-neutral:hover {
  background-color: rgba(128, 128, 128, 0.25);
}
.header-chip.chip-success {
  background-color: rgba(76, 175, 80, 0.15);
  color: #4caf50;
}
.header-chip.chip-success mat-icon {
  color: #4caf50;
}
.header-chip.chip-warning {
  background-color: rgba(255, 152, 0, 0.15);
  color: #ff9800;
}
.header-chip.chip-warning mat-icon {
  color: #ff9800;
}
.header-chip.chip-error {
  background-color: rgba(244, 67, 54, 0.15);
  color: #f44336;
}
.header-chip.chip-error mat-icon {
  color: #f44336;
}
.header-chip.chip-refreshing {
  background-color: rgba(128, 128, 128, 0.15);
  color: rgba(128, 128, 128, 0.9);
}
.header-chip.chip-refreshing mat-icon.spin {
  animation: spin 1s linear infinite;
}
.header-chip.chip-active {
  background-color: rgba(25, 118, 210, 0.15) !important;
  color: var(--tool-accent, #1976d2) !important;
}
.header-chip.chip-active mat-icon {
  color: var(--tool-accent, #1976d2) !important;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
::ng-deep .multiline-tooltip .mdc-tooltip__surface {
  white-space: pre-line !important;
  max-width: 280px !important;
  text-align: left !important;
}

.cost-inline {
  opacity: 0.6;
  font-size: 0.6rem;
  margin-left: 2px;
  white-space: nowrap;
}
.cost-inline::before {
  content: "·";
  margin-right: 4px;
}

:host(.compact) .header-chip {
  padding: 3px 5px;
  gap: 0;
}
:host(.compact) .header-chip > span {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/header-chips/header-chips.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,yEAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,2DAAA;EACA,gBAAA;AACF;AACE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AACJ;AAEE;EACE,YAAA;AAAJ;AAGE;EACE,aAAA;AADJ;AAKE;EACE,2CAAA;EACA,+BAAA;AAHJ;AAKI;EACE,YAAA;AAHN;AAMI;EACE,2CAAA;AAJN;AASE;EACE,yCAAA;EACA,cAAA;AAPJ;AASI;EACE,cAAA;AAPN;AAYE;EACE,yCAAA;EACA,cAAA;AAVJ;AAYI;EACE,cAAA;AAVN;AAeE;EACE,yCAAA;EACA,cAAA;AAbJ;AAeI;EACE,cAAA;AAbN;AAkBE;EACE,2CAAA;EACA,+BAAA;AAhBJ;AAkBI;EACE,kCAAA;AAhBN;AAqBE;EACE,qDAAA;EACA,6CAAA;AAnBJ;AAqBI;EACE,6CAAA;AAnBN;;AAwBA;EACE;IAAO,uBAAA;EApBP;EAqBA;IAAK,yBAAA;EAlBL;AACF;AAqBA;EACE,gCAAA;EACA,2BAAA;EACA,2BAAA;AAnBF;;AAuBA;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AApBF;AAsBE;EACE,YAAA;EACA,iBAAA;AApBJ;;AA0BE;EACE,gBAAA;EACA,MAAA;AAvBJ;AAyBI;EACE,aAAA;AAvBN","sourcesContent":["// Header status chips — unified styling for folder path, token status, usage, pins\n.header-chips {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.header-chip {\n  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;\n  font-size: 0.7rem;\n  letter-spacing: 0.3px;\n  padding: 3px 8px;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  user-select: none;\n  transition: opacity 0.15s ease, background-color 0.15s ease;\n  line-height: 1.2;\n\n  mat-icon {\n    font-size: 12px;\n    width: 12px;\n    height: 12px;\n  }\n\n  .chip-label {\n    opacity: 0.7;\n  }\n\n  &:hover {\n    opacity: 0.85;\n  }\n\n  // Neutral/info style (folder path, unknown status)\n  &.chip-neutral {\n    background-color: rgba(128, 128, 128, 0.15);\n    color: rgba(128, 128, 128, 0.9);\n\n    mat-icon {\n      opacity: 0.8;\n    }\n\n    &:hover {\n      background-color: rgba(128, 128, 128, 0.25);\n    }\n  }\n\n  // Success/healthy style\n  &.chip-success {\n    background-color: rgba(76, 175, 80, 0.15);\n    color: #4caf50;\n\n    mat-icon {\n      color: #4caf50;\n    }\n  }\n\n  // Warning style\n  &.chip-warning {\n    background-color: rgba(255, 152, 0, 0.15);\n    color: #ff9800;\n\n    mat-icon {\n      color: #ff9800;\n    }\n  }\n\n  // Error/critical style\n  &.chip-error {\n    background-color: rgba(244, 67, 54, 0.15);\n    color: #f44336;\n\n    mat-icon {\n      color: #f44336;\n    }\n  }\n\n  // Refreshing state\n  &.chip-refreshing {\n    background-color: rgba(128, 128, 128, 0.15);\n    color: rgba(128, 128, 128, 0.9);\n\n    mat-icon.spin {\n      animation: spin 1s linear infinite;\n    }\n  }\n\n  // Active state (e.g. pins pane open)\n  &.chip-active {\n    background-color: rgba(25, 118, 210, 0.15) !important;\n    color: var(--tool-accent, #1976d2) !important;\n\n    mat-icon {\n      color: var(--tool-accent, #1976d2) !important;\n    }\n  }\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n// Tooltip styling for multiline content\n::ng-deep .multiline-tooltip .mdc-tooltip__surface {\n  white-space: pre-line !important;\n  max-width: 280px !important;\n  text-align: left !important;\n}\n\n// Inline cost label within the usage chip\n.cost-inline {\n  opacity: 0.6;\n  font-size: 0.6rem;\n  margin-left: 2px;\n  white-space: nowrap;\n\n  &::before {\n    content: '·';\n    margin-right: 4px;\n  }\n}\n\n// Compact mode support — consumers apply this via :host-context or container queries\n:host(.compact) {\n  .header-chip {\n    padding: 3px 5px;\n    gap: 0;\n\n    > span {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
